import React, { useEffect, useId, useState } from 'react';
import Section1 from './homesections/Section1';
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import LazyLoad from 'react-lazy-load-image-component';
import LazyLoad from 'react-lazyload';
import Section2 from './homesections/Section2';
import Section3 from './homesections/Section3';
import Section4 from './homesections/Section4';
import Section5 from './homesections/Section5';
import Section6 from './homesections/Section6';
import Section7 from './homesections/Section7';
import Section8 from './homesections/Section8';
import Section10 from './homesections/Section10';
import indiciWeb from '../assets/images/indici-image-1.png'
import Section_one from './homesections/Section_one';
import { StyledDiv } from './homesections/Section5.style';
import { Link } from 'react-router-dom';
import SectionContent from './homesections/SectionContent';
import styled from "styled-components";
import { Spin } from 'antd';
import indiciweb7 from '../assets/images/indiciimage7.webp'
interface Homeprops {
    background?: any;
    title1?:any ;
    title2?:any ;
    dangerouslySetInnerHTML?:any;
    handleMenuItemClick: (menuItemKey?: any) => void;
}
const TextContainer = styled.div`
text-align: center;
`;
const Title = styled.span`
  display: block;
  /* color: #fff;
  line-height: 90px; */
`;
export const Home: React.FunctionComponent<Homeprops> = (props) => {
    const { handleMenuItemClick } = props;
    const [loading, setLoading]=useState(true)
    setTimeout(() => {
      setLoading(false); // Hide loader after 8 seconds
  }, 3000);
    return (
        <React.Fragment>
        <section>
        
            {/* <div className='relative-container '>
            
           {loading ?   <Spin spinning={loading}  fullscreen />:<LazyLoadImage src={indiciweb7} className='w-100'
              placeholderSrc={indiciweb7} alt="Image Alt"/> } 
             
           
            <div className='banner-text'>
                   
            <TextContainer >
                  <Title className="main-heading"> myindici 
                  </Title>
                  <Title className="main-heading"> 
                  Patient Portal</Title>
                </TextContainer>
          </div>
            </div> */}
            {loading ? <Spin spinning={loading}  style={{fontSize:48}} fullscreen /> : <Section1
             background={indiciweb7} title1={`myindici`}
            title2={`Patient Portal`}/>}
            <Section2 />
            <Section3 />
            <Section4  handleMenuItemClick={handleMenuItemClick}/>
            <Section5 handleMenuItemClick={handleMenuItemClick} />
            <Section6 />
            <Section7 />
            <Section8 handleMenuItemClick={handleMenuItemClick}/>
            <Section10 />
            </section>
        </React.Fragment>
    )
}
 
export default Home;